import {Id} from '../../../../shared/models/types';

export class DiscountGroupUser {
  id: Id;
  contact_name: string;
  email: string;
  orders_count: number;
}
